import { Plus, Link2, Settings2 } from "lucide-react";
import { Button } from "../ui/button";
import { format } from "date-fns";

export function CalendarHeader({
  selectedDate,
  googleConnected,
  onConnectGoogle,
  onShowGoogleSettings,
  onAddEvent,
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold text-white font-['Outfit']">
          Calendar
        </h1>
        <p className="text-slate-400 mt-1">
          {format(selectedDate, "MMMM yyyy")}
        </p>
      </div>
      <div className="flex gap-2">
        {googleConnected ? (
          <Button
            variant="outline"
            onClick={onShowGoogleSettings}
            className="border-slate-700 text-emerald-400"
            data-testid="google-calendar-settings"
          >
            <Settings2 size={18} className="mr-2" />
            Google Connected
          </Button>
        ) : (
          <Button
            variant="outline"
            onClick={onConnectGoogle}
            className="border-slate-700"
            data-testid="connect-google-calendar"
          >
            <Link2 size={18} className="mr-2" />
            Connect Google
          </Button>
        )}
        <Button
          onClick={onAddEvent}
          className="bg-indigo-600 hover:bg-indigo-500 glow-primary"
          data-testid="add-event-button"
        >
          <Plus size={18} className="mr-2" />
          Add Event
        </Button>
      </div>
    </div>
  );
}
